import React from 'react';
import { motion } from 'framer-motion';

const DemoVideo = () => {
  return (
    <section id="demo" className="section-padding bg-white" aria-label="Demo" data-testid="demo-section">
      <div className="section-container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-10 md:mb-12"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-[#00e5ff] mb-3 block">
            Demo
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#212121] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="demo-headline"
          >
            See It In Action
          </h2>
          <p className="text-base md:text-lg text-[#5a6b8c] max-w-2xl mx-auto">
            Watch how we built a restaurant ordering chatbot in 3 hours
          </p>
        </motion.div>

        {/* Video Container */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <div className="video-frame rounded-xl overflow-hidden shadow-2xl ring-1 ring-black/5">
            {/* MacOS style dots */}
            <div className="video-dots bg-[#2d2d2d]">
              <span></span>
              <span></span>
              <span></span>
            </div>
            {/* Loom Video Embed */}
            <div className="relative bg-black" style={{ paddingBottom: '53.465346534653456%' }}>
              <iframe 
                src="https://www.loom.com/embed/a67da2e94fde4af68d56bb5f996b25a1" 
                frameBorder="0" 
                webkitallowfullscreen="true" 
                mozallowfullscreen="true" 
                allowFullScreen 
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                title="LitheForce Demo Video"
                data-testid="demo-video-iframe"
              />
            </div>
          </div>
        </motion.div>

        {/* Caption */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-center mt-6 text-[#5a6b8c] max-w-2xl mx-auto"
        >
          This chatbot handles orders 24/7, logs to Google Sheets, and saves 2-3 hours per day
        </motion.p>
      </div>
    </section>
  );
};

export default DemoVideo;
